import { StyleSheet, Text } from "react-native";

import {
  spacing,
  typography,
  useThemedStyles,
  type ThemeColors,
} from "~/styles/theme";

export function PageTitle({
  title,
  subtitle,
}: {
  title: string;
  subtitle?: string;
}) {
  const stylesheet = useThemedStyles(makeStyles);
  return (
    <>
      <Text accessibilityRole="header" style={stylesheet.title}>
        {title}
      </Text>
      {subtitle ? <Text style={stylesheet.subtitle}>{subtitle}</Text> : null}
    </>
  );
}

const makeStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    title: {
      ...typography.display1,
      color: colors.heading,
    },
    subtitle: {
      ...typography.small,
      marginTop: spacing.xs,
      color: colors.mutedForeground,
    },
  });
